<script setup lang="ts" name="HomePage">
import BomBanner from '@/assets/bom-banner.png'
import BannerBg from '@/assets/sass-banner.jpg'
import AccessPaymentIcon1 from '@/assets/step-icon1.png'
import AccessPaymentIcon2 from '@/assets/step-icon2.png'
import AccessPaymentIcon3 from '@/assets/step-icon3.png'

import LoginNew from '@/components/loginNew/index.vue'

import { getSassNotices } from '@mp/api/sdpPro/CommonControler.js'
import { IconFont } from '@mp/component'
import { useIsSp } from '@mp/hooks'

import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'

const { isNotSp, shortName } = useIsSp()

const SOUNCE_DATA = {
  accountData: [{
    num: '550',
    desc: '万+商户账户',
  },
  {
    num: '1.1',
    desc: '亿+个人账户',
  },
  {
    num: '100',
    desc: '亿+每周最高处理交易资金',
  },
  ],
  proList: [
    {
      headerInfo: {
        zh: '聚合支付',
        en: 'PAYMENT PRODUCTS',
      },
      list: [
        {
          href: 'https://b.shengpay.com/introduce.html?intr=pay_0',
          title: 'APP支付',
          desc: 'SDK集成 轻松收款',
        }, {
          href: 'https://b.shengpay.com/introduce.html?intr=pay_2',
          title: '小程序支付',
          desc: 'API快速接入 支持分账',
        },
        {
          href: 'https://b.shengpay.com/introduce.html?intr=pay_1',
          title: 'H5支付',
          desc: '移动网页支付 灵活快捷',
        },
        {
          href: 'https://b.shengpay.com/introduce.html?intr=pay_4',
          title: '扫码支付',
          desc: '聚合扫码 灵活定制',
        },
      ],
    },
    {
      headerInfo: {
        zh: '资金管理',
        en: 'FUND PRODUCTS',
      },
      list: [{
        href: 'https://b.shengpay.com/introduce.html?intr=capital_1',
        title: '收款到银行账户',
        desc: '自动到银行卡 方便快捷',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=capital_0',
        title: '商户分账',
        desc: '多级分账 灵活定制',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=capital_2',
        title: '企业付款到钱包',
        desc: '实时到账 轻松付款',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=capital_3',
        title: '企业付款到银行卡',
        desc: '无限额 多级复核保障',
      },
      ],
    },
    {
      headerInfo: {
        zh: '钱包服务',
        en: 'MONEY SERVICE',
      },
      list: [{
        href: 'https://b.shengpay.com/introduce.html?intr=wallet_0',
        title: '钱包账户',
        desc: '会员专属钱包 安全可靠',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=wallet_1',
        title: '会话红包',
        desc: '会话内转账及红包 提升粘性',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=wallet_2',
        title: '会员卡',
        desc: '个性化定制',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=wallet_3',
        title: '卡券包',
        desc: '卡券一站式管理',
      },
      ],
    },
    {
      headerInfo: {
        zh: '营销工具',
        en: 'MARKETING TOOLS',
      },
      list: [{
        href: 'https://b.shengpay.com/introduce.html?intr=market_0',
        title: '现金红包',
        desc: '红包促活 快速拉新',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=market_1',
        title: '代金券',
        desc: '免开发 便捷发券',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=market_2',
        title: '九宫格',
        desc: '免开发 个性化专属运营',
      },
      {
        href: 'https://b.shengpay.com/introduce.html?intr=market_3',
        title: '广告投放',
        desc: '大数据引擎 精准投放',
      },
      ],
    },
  ],
}

// 公告
const { data: notices } = useQuery({
  queryKey: ['get:sass:notices'],
  queryFn: () => getSassNotices({}, {
    customOptions: {
      errorMessageMode: 'none',
    },
  }),
  refetchOnWindowFocus: false,
})

// 了解我们的SaaS产品
const sassContent = computed(() => SOUNCE_DATA?.proList)
const accountContent = computed(() => SOUNCE_DATA?.accountData)

// 接入盛付通支付
const AccessPaymentContents = [{
  step: '01',
  title: '注册登录',
  desc: '通过注册实名认证的盛付通账号即可成为商家中心用户。',
  icon: AccessPaymentIcon1,
}, {
  step: '02',
  title: '产品签约',
  desc: '选择产品并提交相关资料签约，一般一个工作日即可通过审核。',
  icon: AccessPaymentIcon2,
}, {
  step: '03',
  title: '接入上线',
  desc: '部分产品可能需要一定的开发集成能力，完成接入即可上线。',
  icon: AccessPaymentIcon3,
}]
</script>

<template>
  <!-- banner -->
  <section class="relative bg-[#050c50] bg-center bg-no-repeat bg-[length:2048px_auto] overflow-hidden" :style="{ backgroundImage: `url(${BannerBg})` }">
    <div class="content-container flex justify-end pt-[45px] pb-[120px]">
      <!-- login content -->
      <div>
        <LoginNew />
      </div>
    </div>

    <div class="bg-[rgba(0,0,0,0.5)] absolute bottom-0 left-0 right-0">
      <div class="h-[100px] content-container text-[#fff] flex items-center justify-between text-lg line-height-none">
        <div v-for="item in accountContent" :key="item.num">
          <span class="text-[46px]">{{ item.num }}</span> {{ item.desc }}
        </div>
      </div>
    </div>
  </section>

  <!-- notices -->
  <section v-if="!isNotSp" class="content-container mt-8 text-sm flex items-start h-[24px] overflow-hidden">
    最新公告

    <a v-for="item in notices" :key="item.title" :href="item.link" target="_blank" class="text-xs text-[#9e9e9e] hover:text-[#0ca6fe] ml-[60px] flex flex-wrap items-start">

      <i class="w-[12px] h-[12px] rounded-full bg-[#0ca6fe] border-solid border-[#fff] border-[2px] inline-block outline-[#0ca6fe] outline-solid outline-2 mr-3 mt-[5px]" />
      <span class="flex-1 line-height-6">{{ item.title }}</span>
    </a>

    <a href="https://b.shengpay.com/news/" target="_blank" class="ml-auto text-[#9e9e9e] hover:text-[#0ca6fe]">更多公告>></a>
  </section>

  <section class="py-16">
    <h3 class=" group-title">
      了解我们的SaaS产品
    </h3>
    <div v-if="!isNotSp" class="content-container grid grid-cols-4 max-lg:grid-cols-2 gap-4">
      <div v-for="(item, index) in sassContent" :key="item.headerInfo?.zh" class="rounded-2 overflow-hidden shadow-xl">
        <h4 class="text-base pt-[23px] pb-[23px] pl-[20px] font-900 bg-[#0ca6fe] text-[#fff] bg-no-repeat sass-block-item" :class="`sass-block-${index}`">
          {{ item.headerInfo?.zh }}
          <span class=" text-[10px] block opacity-40 line-height-none mt-1">{{ item.headerInfo?.en }}</span>
        </h4>
        <a v-for="i in item.list" :key="i.title" :href="i.href" target="_blank" class=" hover:bg-[#f6f6f6] text-n-600 pt-[20px] pr-[12px] pb-[20px] pl-[50px] block relative group">
          <label class=" font-900 block text-n-800 text-base">{{ i.title }}</label>
          <p class="m-0 text-xs mt-2">
            {{ i.desc }}
          </p>
          <i class=" w-[16px] h-[16px]  bg-[#fff] rounded-full absolute left-[20px] top-[24px] border-solid border-[4px] border-[#0ca6fe]" />
          <IconFont type="icon-chevron-right" class="text-[24px] text-[#0ca6fe] absolute right-[10px] top-1/2 -translate-y-1/2 transition-all group-hover:translate-x-1" />
        </a>
      </div>
    </div>
  </section>

  <section
    class="overflow-hidden h-[440px] bg-[#0c92de] bg-center bg-no-repeat bg-[length:2048px_auto]" :style="{
      backgroundImage: `url(${BomBanner})`,
    }"
  />

  <section class="py-16">
    <h3 class=" group-title">
      接入{{ shortName }}支付
    </h3>
    <div class="content-container flex items-center  max-lg:flex-col">
      <template v-for="item in AccessPaymentContents" :key="item.step">
        <div
          class="bg-[#eaeaea] rounded-2 flex-1 pt-[50px] pr-[70px] pb-[60px] pl-[45px] bg-no-repeat" :style="{
            backgroundImage: `url(${item.icon})`,
            backgroundSize: '78px auto',
            backgroundPosition: 'right 18px top 18px',
          }"
        >
          <b class="text-[#b5c2ca] text-[44px]">{{ item.step }}</b>
          <h5 class="text-[24px] text-black mb-6">
            {{ item.title }}
          </h5>
          <p class="text-[#666]">
            {{ item.desc }}
          </p>
        </div>

        <IconFont v-if="item.step !== '03'" type="icon-chevron-right" class="text-[38px] text-n-80 mx-[40px] max-lg:rotate-90 max-lg:my-6" />
      </template>
    </div>
  </section>
</template>

 <style scoped>
    .group-title {
        @apply text-center text-2xl mb-12 font-black;
        &::after {
            content: '';
            @apply  block mx-auto mt-4 w-[40px] h-[5px] bg-[#0ca6fe];
        }
    }

    .sass-block-0 {
      background-image: url('@/assets/pro-icon1.png');
      background-position: bottom -10px right 10px;
    }
    .sass-block-1 {
      background-image: url('@/assets/pro-icon2.png');
      background-position: bottom right 10px;
    }
    .sass-block-2 {
      background-image: url('@/assets/pro-icon3.png');
      background-position: bottom right 10px;
    }
    .sass-block-3 {
      background-image: url('@/assets/pro-icon4.png');
      background-position: bottom right 10px;
    }
</style>
